// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoItem_wrapper__hpD1g","title":"InfoItem_title__pmzDY","value":"InfoItem_value__dYrCj"};